export default {
  brand: 'Basetao Spreadsheet',
  nav: {
    home: 'Home',
    guide: 'Shopping Guide',
    categories: 'Categories',
  },
  buttons: {
    basetaoSpreadsheet: 'Basetao Spreadsheet',
    buyNow: 'Buy It Now',
    readGuide: 'Read the Guide',
    visitMainSite: 'Visit Main Website',
    browseCategories: 'Browse Categories',
  },
  lang: {
    label: 'Language',
    english: 'English',
    french: 'Français',
    german: 'Deutsch',
    spanish: 'Español',
    portuguese: 'Português',
  },
  footer: {
    tagline: 'Your independent Basetao Spreadsheet resource.',
    disclaimer:
      'This website is an independent informational resource and is not the official Basetao website unless explicitly stated.',
    categoriesTitle: 'Categories',
    resourcesTitle: 'Resources',
    guideLink: 'Basetao Spreadsheet Guide',
    mainSiteLink: 'Main Website',
    rights: 'All rights reserved.',
  },
  notFound: {
    title: 'Page not found',
    desc: 'The page you are looking for may have been moved or no longer exists. Head back home or visit the main website to keep shopping.',
    backHome: 'Back to Home',
  },
};